import $store from '@/store'
import { simpleClone } from '@/util'
import qs from 'query-string'

export default async (to, from, next) => {
  const accessToken = 'accessToken'
  const refreshToken = 'refreshToken'
  const q = simpleClone(to.query)

  if (q[accessToken] && q[refreshToken]) {
    await $store.dispatch('auth/signinSuccess', {
      accessToken: q[accessToken],
      refreshToken: q[refreshToken],
    })
    delete q[accessToken]
    delete q[refreshToken]
    location.replace(`${to.path}?${qs.stringify(q)}`)
    return
  }
  next()
}
